// import axios from 'axios'
import router from '../../router'
import { auth } from '../../firebase'

export default {
  signIn (context, payload) {
    auth
      .signInWithEmailAndPassword(payload.email, payload.password)
      .then((response) => {
        console.log(response.user.emailVerified)
        if (response.user.emailVerified) {
          router.push('/')
        } else {
          auth.signOut()
          alert('Email onayı gereklidir.')
        }
      })
      .catch((error) => {
        let errMsg
        switch (error.code) {
          case 'auth/invalid-email':
            errMsg = 'Invalid email'
            break
          case 'auth/user-not-found':
            errMsg = 'No account with that email was found'
            break
          case 'auth/wrong-password':
            errMsg = 'Incorrect password'
            break
        }
        alert(errMsg)
      })
    // return axios
    //   .post(
    //     `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${context.state.fbToken}`,
    //     {
    //       email: payload.email,
    //       password: payload.password,
    //       returnSecureToken: true
    //     }
    //   )
    //   .then((response) => {
    //     if (response.status === 200) {
    //       console.log(response.data.idToken)
    //       context.commit('tokenCommit', response.data.idToken)
    //       localStorage.setItem('Token', response.data.idToken)
    //       router.push({ name: 'social.list' })
    //     }
    //   })
    //   .catch(() =>
    //     alert('Yanlış!!!')
    //   )
  },
  signUp (context, payload) {
    auth
      .createUserWithEmailAndPassword(payload.email, payload.password)
      .then((data) => {
        auth.currentUser.sendEmailVerification()
          .then(() => {
            router.push('/auth/signin')
          })
      })
      .catch(error => {
        console.log(error.code)
        alert(error.message)
      })
    // return axios
    //   .post(
    //     `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${context.state.fbToken}`,
    //     {
    //       email: payload.email,
    //       password: payload.password,
    //       returnSecureToken: true
    //     }
    //   )
    //   .then((response) => {
    //     if (response.status === 200) {
    //       // const auth = getAuth()
    //       // sendEmailVerification(auth.currentUser)
    //       // console.log(auth.currentUser)
    //       //   .then(() => {
    //       //     alert('Send Mail!')
    //       //   })

    //       router.push('/auth/signin')
    //     }
    //   })
  },
  signOut () {
    // localStorage.removeItem('Token')
    auth.signOut()
    router.push('/auth/signin')
  },
  resetPassword (context, payload) {
    auth
      .sendPasswordResetEmail(payload)
      .then(() => { })
      .catch((error) => {
        alert(error)
      })
  }
}
